import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component que faz scroll automático para o topo quando a rota muda
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll para o topo quando a rota muda
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}